import script from "./MainOnboardPasswordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainOnboardPasswordComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainOnboardPasswordComponent.vue?vue&type=style&index=0&id=0d24d93c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d24d93c"]])

export default __exports__